export default "__VITE_PUBLIC_ASSET__b691ff5c__"